module.exports = __webpack_public_path__ + "static/media/measure.3e6b2e49.svg";